
$( document ).ready(function() {
 

  $('.Faq__Item').click(function(){
  	$(this).find('.Faq__AnswerWrapper').toggleClass('active');
  })


  $('.flex-quotes').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true
  })
  
 //collection slick slider 
  $('.slick-slider-collection').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }     
    ]
  });
  
  //collection slick slider 
  $('.slick-slider-products').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }     
    ]
  
  });

  //fire up the AOS
  AOS.init();
  
  //footer menu box
  $('.foot-menu-box').click(function(){
  	$(this).find('ul').first().toggleClass('active');
    $(this).find('h3').first().toggleClass('active');
  });
  
  //Navigation Filter Dropwdown
  $('.filter-top .Collapsible__Button').click(function(){
    
    //check for active headline
    if($(this).hasClass('active')){
       $('.filter-top .Collapsible__Inner').removeClass('active');
       $(this).removeClass('active');
    } else {
      
      //clear all the top buttons
      $('.filter-top .Collapsible__Button').removeClass('active');
      
      //add active class to the the link
      $(this).addClass('active');  
  	  
      //remove the filter actives 
      $('.filter-top .Collapsible__Inner').removeClass('active');

      $(this).closest('.filter-top').find('.Collapsible__Inner').addClass('active');
    }
  })

  
});
  